import { mailboxHooks } from 'features/messaging'

import { api } from './api'

export function useChatScheduled() {
	const id = mailboxHooks.useCurrentId()

	return api.useScheduledMessagesQuery(
		{
			$filter: `conversation_id eq '${id}'`,
			$orderby: 'time asc',
			$take: 20
		},
		{
			skip: !id
		}
	)
}
